import ReactDOM from "react-dom";
import React, {Fragment} from "react";
import MainPaginator from "./Paginator/MainPaginator";
import AccordionBlock from "./Components/AccordionBlock";
import BannerBlock from "./Components/MiniBanner";
import Axios from "axios";

const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";
/*
    AL PUSH VA IMPOSTATO A FALSE
    PER SVILUPPO TRUE
*/
/* *********************----  basehost ---******************************************* */
let host__ = window.location.host;
let prod_Loc = host__.match(/localhost/g);
let isProd = false;
if( prod_Loc ){
    isProd= true
}

const basehost = isProd ?  'https://petpassion.dgthouse.com/' : '/';
/* *********************----  basehost ---******************************************* */
/*
    AL PUSH VA IMPOSTATO A FALSE
    PER SVILUPPO TRUE
*/
export default  class Smistamento extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            dogsObjectResult:[],
            filters:[
                {
                    taglie:['Piccola','Media','Grande'],
                    compagnia:['Bambini','Anziani'],
                    luogo:['Appartamento','Spazi esterni'],
                    pricipale:['Compagnia','Riporto','Cane Guida','Pet Therapy','Caccia','Soccorso','Salvataggio','Guardia']
                }
            ],
            filtersTag:[],
            size:[],
            ideal_context:[],
            ideal_people:[],
            main_activity:[],
            searchByName:'',
            queryLetters:'',
            isActive: false,
            isLoading:false,
           // staticImg: document.getElementById("smistamento-razze").getAttribute("staticImageBase") || 'https://dt-petpassion-dgthouse.s3.amazonaws.com/s/breeds/',
            staticImg: 'https://dt-petpassion-dgthouse.s3.amazonaws.com/s/breeds/',
            letters : ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','x','y','z'],

        }
        this.renderFilterLetter = this.renderFilterLetter.bind(this);
        this.renderFilteredByLetter = this.renderFilteredByLetter.bind(this);
        this.callFilterChoose =    this.callFilterChoose.bind(this);
        this.getDogsByLetter =      this.getDogsByLetter(this);
        this.renderResetFilterBtn =  this.renderResetFilterBtn(this);
        this.searchOnlyByName = this.searchOnlyByName.bind(this);
        this.resetMobileTableBtn = this.resetMobileTableBtn.bind(this);
    }
    componentDidMount() {
        //La prima vota chiama all
        //per filtri in ordine alfabetico
        // call renderFilterLetter()
        this.setState({ isLoading:true })
        Axios.get( '/razze-cani-dalla-a-alla-z/filter/all').
        then( (data) => {
            //let result = data.data.data.number.results ;
            console.log(data.data[0] );
            //pet_breed.name
            this.setState({ dogsObjectResult:  data.data[0] })
            this.setState({ isLoading:false })
        } )
    }

    searchOnlyByName(e){
        this.setState({
            searchByName:e.target.value
        })
    }
    resetMobileTableBtn(){
        let letterSelected = document.querySelector('.spanLetter.selected');
        if(letterSelected){
            letterSelected.classList.remove('selected');
        }

        let filterActive = Array.from(document.querySelectorAll('.filter-link.actived'))
        for (let element of filterActive) {
            element.classList.remove('actived')
        }
        this.setState({
            size:[],
            ideal_context:[],
            ideal_people:[],
            main_activity:[],
            queryLetters:'',
            isLoading:true
        })

        Axios.get('/razze-cani-dalla-a-alla-z/filter/all').
        then( (data) => {
            //let result = data.data.data.number.results ;
            console.log(data.data[0] );
            //pet_breed.name
            this.setState({ dogsObjectResult:  data.data[0] })
            this.setState({ isLoading:  false })
        } )
    }
    renderResetFilterBtn(){
        return (<button onClick={
            ()=>{

                let letterSelected = document.querySelector('.spanLetter.selected');
                if(letterSelected){
                    letterSelected.classList.remove('selected');
                }

                let filterActive = Array.from(document.querySelectorAll('.filter-link.actived'))
                for (let element of filterActive) {
                    element.classList.remove('actived')
                }
                this.setState({
                    size:[],
                    ideal_context:[],
                    ideal_people:[],
                    main_activity:[],
                    queryLetters:'',
                    isLoading:true
                })

                Axios.get('/razze-cani-dalla-a-alla-z/filter/all').
                then( (data) => {
                    //let result = data.data.data.number.results ;
                    console.log(data.data[0] );
                    //pet_breed.name
                    this.setState({ dogsObjectResult:  data.data[0] })
                    this.setState({ isLoading:  false })
                } )
            }
        } className={'reset-filter-all'}> <span className={"glyphicon glyphicon-refresh"}></span> Reset </button>)
    }

    renderFilterLetter() {

        const letter = this.state.letters.map((item,index)=>{

                return (
                    <div onClick={ (e) =>  {
                        let itemSelected = document.querySelector('.spanLetter.selected');
                        if(itemSelected){  itemSelected.classList.remove('selected'); }

                        this.setState({ isLoading:true })


                        // document.querySelector('.spanLetter.selected').classList.remove('selected');

                        if( e.target.classList  == 'spanLetter selected' ) {
                            e.target.classList.remove('selected')
                        }else{
                            e.target.classList.add('selected')
                        }

                        Axios.get( '/razze-cani-dalla-a-alla-z/filter/'+item ,{
                            params:{
                                multi: {
                                    size:[...this.state.size],
                                    ideal_context:[...this.state.ideal_context] ,
                                    ideal_people:[...this.state.ideal_people ],
                                    main_activity:  [...this.state.main_activity]

                                },
                            }
                        })
                            .then( (data) => {
                                console.log('renderFilterLetter', data.data);
                                this.setState({ dogsObjectResult: data.data[0] , queryLetters:item  })
                                this.setState({ isLoading:false })
                            } )
                    }  } key={index} className={'letter'}>
                        <div  className={'spanLetter'} >{item} </div>
                    </div>
                )

        });
        return letter;
    }

    getDogsByLetter(letter){ }

    callFilterChoose(e){
        if( e.target.classList  == 'filter-link actived' ){
            e.target.classList.remove('actived')
        }else{
            e.target.classList.add('actived')
        }
        console.log( e.target.className );
    }

    /*  METODO DI RENDER DINAMICO DEI FILTRI
    *   BINDATO AL CLICK SI OCCUPA DEI FILTRI MULTIPLI ON/OFF SUDDIVISO IN GRUPPI
    *   SE SI VOLESSE AGGIUNGERE UN NUOVO GRUPPO O SEMPLICEMNTE TAG BASTERà MODIFICARE
    *   - [ this.state.filters ]
    *   - CALL RENDER renderFilteredByLetter([nome chive da ciclare per il render])
    * */
    renderFilteredByLetter(filter){

        let filter__button = this.state.filters[0][filter].map( (item,index) => {

            return  <button onClick={ (e) => {

                this.callFilterChoose( e )

                let dataParams = {};
                switch(filter) {
                    case 'taglie':
                        this.state.size.indexOf(item) === -1 ?  this.setState({size:[...this.state.size, item]}) : this.state.size.splice(this.state.size.indexOf(item) , 1);
                        break;
                    case 'compagnia':
                        this.state.ideal_people.indexOf(item) === -1 ?  this.setState({ideal_people:[...this.state.ideal_people, item]}) : this.state.ideal_people.splice(this.state.ideal_people.indexOf(item) , 1);
                        break;
                    case 'luogo':
                        this.state.ideal_context.indexOf(item) === -1 ?  this.setState({ideal_context:[...this.state.ideal_context, item]}) : this.state.ideal_context.splice(this.state.ideal_context.indexOf(item) , 1);
                        break;
                    case 'pricipale':
                        this.state.main_activity.indexOf(item) === -1 ?  this.setState({main_activity:[...this.state.main_activity, item]}) : this.state.main_activity.splice(this.state.main_activity.indexOf(item) , 1);
                        break;
                    default:
                        break;
                    // code block
                }

                this.setState({filter:  [...this.state.filtersTag, item ]  } ,   () =>{

                    this.setState({ isLoading:true })
                    let endpoint  = '/razze-cani-dalla-a-alla-z/filter/'+this.state.queryLetters  ;
                    if( this.state.queryLetters.length <= 0 ){
                        endpoint = "/razze-cani-dalla-a-alla-z/filter/all";
                    }

                     Axios.get(endpoint ,{

                        params:{
                            multi: {
                                size:[...this.state.size],
                                ideal_context:[...this.state.ideal_context] ,
                                ideal_people:[...this.state.ideal_people ],
                                main_activity:  [...this.state.main_activity]
                            },
                        }
                    }).then( (data) => {
                        console.log('renderFilterLetter', data.data);
                        this.setState({ dogsObjectResult: data.data[0] })
                         this.setState({ isLoading:false })

                    })
                })

            }} className={'filter-link ' }   key={index} >{ item }</button>;
        })
        return <div  className={'wrap-filter ' } >   { filter__button }  </div>
    }

    toggleOpenBlcok(e){

        let accordionBody = e.target.parentNode.querySelector('.filters_dog');

        if( accordionBody.classList  == 'filters_dog' ) {
            accordionBody.classList.add('open');
            accordionBody.style.display = 'block'
        }else{
            accordionBody.classList.remove('open');
            accordionBody.style.display = 'none';
        }
    }

    render(){
        return (
            <Fragment>
                <div id="smistamento-razze" className={""}>
                    <img className={'img-header'}  src={ ASSETS_BASE + '/images/header-smistamento.png'} />
                </div>
                <div id={'smistamento-content'}>
                    <div className={'item'} id={'left'} >

                      <div className={'search_dog'}>
                            <p className={'label-search'}>Non trovi la razza? Cerca qui!</p>
                        </div>
                        <div className={'wrap-input-search-icon'}>
                           <div className={"input-with-icon"}>
                                <input type={"text"}
                                       className={"form-control"}
                                       id={'search-only-name'}
                                       placeholder={"Cerca"}
                                       onChange={ (e)=> { this.searchOnlyByName(e) } }
                                />
                                    <div    className={"btn btn-default icon"}

                                        onClick={()=>{
                                            this.setState({ isLoading:true })
                                            Axios.get( "/razze-cani-dalla-a-alla-z/filter-by-name" ,{

                                                params:{
                                                    searchByName:this.state.searchByName
                                                }
                                            }).then( (data) => {
                                                console.log('renderFilterLetter', data.data);
                                                this.setState({ dogsObjectResult: data.data[0] })
                                                let clearSeacrh = document.querySelector('#search-only-name');
                                                clearSeacrh.value='';
                                                this.setState({ searchByName:'' })
                                                this.setState({ isLoading:false })
                                            })
                                        }}
                                    >
                                        <span className={"glyphicon glyphicon-search"}></span>
                                    </div>
                            </div>
                        </div>
                        <div className={'filters_dog'}>
                            <div className={'all-filter'}>
                                <p className={'label-filter'}> Filtra le razze attraverso: </p>
                                <br />
                                <p className={'macro-filter'}>Taglie</p>
                                {   this.renderFilteredByLetter('taglie' )  }
                                <p className={'macro-filter'}>Compagnia</p>
                                {   this.renderFilteredByLetter('compagnia')  }
                                <p className={'macro-filter'}>Luogo ideale</p>
                                {   this.renderFilteredByLetter('luogo' )  }
                                <p className={'macro-filter'}>Principale attività</p>
                                {   this.renderFilteredByLetter('pricipale' )  }
                            </div>
                        </div>

                        <BannerBlock
                            testo={'Confronta le razze'}
                            urlImage={ ASSETS_BASE+ '/images/smistamento-left.png' }
                            pageurl={'/confronto-razze'}
                            />

                    </div>
                    <div className={'item'} id={'center'}>
                        <h1 className={'title'}>Razze di cani: l’elenco completo con immagini e nomi</h1>
                        {/*filter tag solo tablet e mobile   */}
                        <div id={'accordion-block-only-768'}  >
                            <button className={'acc-btn btn-filter-mobile-only'} onClick={ (e) => this.toggleOpenBlcok(e) }>
                             <span className={'glyphicon glyphicon-filter'}></span>
                                Filtri
                            </button>
                            <button
                                onClick = {  ()=> { this.resetMobileTableBtn() } }
                                    className={'acc-btn btn-filter-mobile-only'} >
                                <span className={'glyphicon glyphicon-refresh'}></span>
                                Reset  </button>

                            {/*input search */}
                            <div className={'wrap-input-search-icon'} style={{marginTop:'10px',padding:'0px'}}>
                                <div className={"input-with-icon"}>
                                    <input type={"text"}
                                           className={"form-control"}
                                           id={'search-only-name'}
                                           placeholder={"Cerca"}
                                           onChange={ (e)=> { this.searchOnlyByName(e) } }
                                    />
                                    <div    className={"btn btn-default icon"}

                                            onClick={()=>{
                                                this.setState({ isLoading:true })
                                                Axios.get("/razze-cani-dalla-a-alla-z/filter-by-name" ,{

                                                    params:{
                                                        searchByName:this.state.searchByName
                                                    }
                                                }).then( (data) => {
                                                    console.log('renderFilterLetter', data.data);
                                                    this.setState({ dogsObjectResult: data.data[0] })
                                                    let clearSeacrh = document.querySelector('#search-only-name');
                                                    clearSeacrh.value='';
                                                    this.setState({ searchByName:'' })
                                                    this.setState({ isLoading:false })
                                                })
                                            }}
                                    >
                                        <span className={"glyphicon glyphicon-search"}></span>
                                    </div>
                                </div>
                            </div>
                            {/*input search*/}




                            <div className={'filters_dog'}>
                                <div className={'all-filter'}>
                                    <p className={'label-filter'}> Filtra le razze attraverso: <span

                                        className={'glyphicon glyphicon-remove'}
                                        style={{float:'right',cursor:'pointer'}}
                                        onClick={()=>{
                                            let filterPanel = document.querySelector('.filters_dog.open');
                                            filterPanel.classList.remove('open');
                                            filterPanel.style.display="none";
                                    }}> </span>
                                    </p>
                                    <br />
                                    <p className={'macro-filter'}>Taglie</p>
                                    {   this.renderFilteredByLetter('taglie' )  }
                                    <p className={'macro-filter'}>Compagnia</p>
                                    {   this.renderFilteredByLetter('compagnia')  }
                                    <p className={'macro-filter'}>Luogo ideale</p>
                                    {   this.renderFilteredByLetter('luogo' )  }
                                    <p className={'macro-filter'}>Principale attività</p>
                                    {   this.renderFilteredByLetter('pricipale' )  }
                                </div>
                            </div>
                        </div>
                         {/*filter tag solo tablet e mobile   */}

                        <p className={'description'}>Sono molti i criteri che guidano la scelta di <span className={'bolder'}>adottare un nuovo amico a quattro zampe</span>; tra questi sicuramente ci sono la taglia e la razza del cane.

                            Cosa si intende per <span className={'bolder'}>“cane di razza”</span>? Le razze sono frutto di un’attenta selezione effettuata dagli allevatori al fine di creare degli esemplari che abbiano determinate caratteristiche; appartenere ad una razza significa infatti essere in possesso di una struttura fisica che rientri in certi standard riconosciuti dalla FCI, l’ente responsabile della certificazione delle razze.

                            Ecco un <span className={'bolder'}>elenco di tutte le razze di cani in ordine alfabetico</span>, con immagini e caratteristiche di ogni razza, per aiutarti a scegliere il pet che fa per te a seconda delle tue esigenze. Infondo all’elenco, troverai consigli e suggerimenti utili sui cani di <span className={'bolder'}>tutte le taglie.</span></p>
                        <br/>
                        <div className={'container-letters'}>
                            {   this.renderFilterLetter()  }
                        </div>
                        <div className={'wrap-btn-reset'}>
                            {   this.renderResetFilterBtn   }
                        </div>

                        {
                            this.state.isLoading == true &&
                            (  <div className={'lds-dual-ring'} ></div> )
                        }
                        {   this.state.isLoading == false && this.state.dogsObjectResult.length  > 0 &&
                            <MainPaginator dataDogs={ this.state.dogsObjectResult } pathBaseImage={ this.state.staticImg } />
                        }{ this.state.isLoading == false && this.state.dogsObjectResult.length  == 0 &&
                                <p className={'no-data'}>Nessun Risultato :(</p>
                        }


                        <p className={'text-description'}>
                            Secondo l’ENCI, Ente Nazionale Cinofilia Italiana,
                            <b className={'bolder-text'}>esistono ad oggi circa 400 razze di cani nel mondo.</b> La maggior parte di queste non sono conosciute ai più,
                            in quanto le razze più diffuse sono in genere i <b className={'bolder-text'}>cani di taglia piccola o media</b>,
                            per la possibilità di tenerli in appartamento, e le <a href={"https://www.petpassion.tv/blog/razze-cani-adatte-bambini-43685"}>razze di
                            cani più adatte ai bambini </a>, dati i comprovati benefici del rapporto cane-bambino.
                        {/* </h2>
                        <h2  className={'text-description'}> */}
                            Esistono tuttavia <b className={'bolder-text'}>molti modi per dividere in categoria i cani di razza</b>:
                            se teniamo conto delle dimensioni possiamo distinguere tra
                            <b className={'bolder-text'}>razze di cani grandi, razze di cani piccoli e razze di cani medio piccole</b>;
                            se usiamo come criterio l’utilizzo che se n’è fatto nel tempo possiamo individuare ad esempio le
                            <b className={'bolder-text'}>razze di cani da pastore</b>; infine, seguendo un criterio geografico si possono indicare
                            <b className={'bolder-text'}> i cani di razza europei</b>.
                        </p>

                        {/* Magari utilizzare array di oggetti per loop ?? ( meglio :) ) */}
                        <AccordionBlock
                            titleAccordion={'Razze di cani grandi'}
                            bodyAccordion={<Fragment>Si parla di cani di taglia grande quando il loro <b className={'bolder-text'}>peso supera i 26 chili</b>,
                                se supera i 45 chili si parla di <b className={'bolder-text'}>cani giganti.</b> Nonostante la loro imponente stazza, si tratta di
                                <b className={'bolder-text'}>cani molto affettuosi e legati al proprietario,</b> dal quale hanno costantemente bisogno di ricevere attenzioni.
                                Eppure, per adottare un cane di taglia grande è opportuno <b className={'bolder-text'}>conoscere almeno le tecniche base dell’addestramento,</b>
                                per evitare che anche solo accidentalmente l’animale possa fare male a qualcuno, nonché avere a disposizione uno spazio
                                all’aperto, adeguato alle sue esigenze. I cani grandi sono molto impegnativi, sia perché richiedono tempo e dedizione,
                                sia perché hanno bisogno di ricevere cure particolari. Sono in tanti a scegliere di vivere con un cane grande,
                                <b className={'bolder-text'}>ottimo amico e fedele guardia del corpo:</b>
                                come resistere alla dolcezza
                                dell’<a target={'_blank'} href='https://www.petpassion.tv/blog/hachiko-scatena-lakita-mania-ecco-i-rischi-6845'>Akita Inu</a>,
                                alla possenza del <a target={'_blank'} href={'https://www.petpassion.tv/blog/come-crescere-ed-educare-un-rottweiler-19689'}>Rottweiler</a> o
                                alla bellezza del <a href={'https://www.petpassion.tv/blog/malattie-e-parassiti-del-siberian-husky-15963'} target={'_blank'}>Siberian Husky?</a>
                            </Fragment>}
                        />
                        <AccordionBlock
                            titleAccordion={'Razze di cani medi e piccoli'}
                            bodyAccordion={<Fragment>I <b>cani di taglia media e piccola</b> sono più diffusi rispetto ai cani di taglia grande, dato che le loro dimensioni gli permettono di vivere serenamente anche in un contesto urbano.
                                <b className={'bolder-text'}>I cani di taglia media</b> possono pesare dagli <b className={'bolder-text'}>11 ai 25 chili</b> e sono <b className={'bolder-text'}>ottimi cani da compagnia:</b> la loro stazza non troppo grande li rende molto attivi ed energici, motivo per cui questi animali hanno bisogno di fare costante attività fisica, come correre, giocare e fare lunghe passeggiate.
                            </Fragment>}
                        />


                        <AccordionBlock
                            titleAccordion={'Cani di taglia media'}
                            bodyAccordion={<Fragment> Non a caso molti cani di taglia media sono <b className={'bolder-text'}>cani da caccia</b>(come l’<a target={'_blank'} href={'https://www.petpassion.tv/blog/lepagneul-breton-cane-da-caccia-e-da-compagnia-7228'}>Epagneul Breton</a>),
                                proprio per la loro propensione al movimento. Sono tuttavia cani che si adattano bene anche alla vita in appartamento,
                                purché gli vengano concessi gli opportuni spazi vitali in cui muoversi.
                                Tra i cani medi più conosciuti ci sono il <a target={'_blank'} href={'https://www.petpassion.tv/blog/il-chow-chowil-cane-dellimperatore-21622'}>Chow Chow</a>,
                                detto anche Cane Leone, il <a target={'_blank'} href={"https://www.petpassion.tv/blog/cane-di-razza-samoiedo-56208"}>Samoiedo</a> e il famosissimo <a target={'_blank'} href={'https://www.petpassion.tv/blog/carattere-e-caratteristiche-del-labrador-21893'}>Labrador</a>. </Fragment>}
                        />
                        <AccordionBlock
                            titleAccordion={'Cani di taglia piccola'}
                            bodyAccordion={<Fragment> I <b className={'bolder-text'}>cani di taglia piccola</b> arrivano a pesare <b className={'bolder-text'}>massimo 10 chili</b>
                                e già questo basterebbe a spiegare perché sono i cani <b className={'bolder-text'}>più diffusi tra gli animali
                                    da compagnia</b>. La loro piccola taglia li rende compagni perfetti per la <b className={'bolder-text'}>vita della città</b>,
                                perché possono essere quasi portati ovunque senza difficoltà e perché non richiedono cure particolari.
                                I cani piccoli si adattano facilmente alla vita casalinga e per loro sono sufficienti le passeggiate quotidiane
                                con il proprio amico umano. Tra le razze di cani di taglia piccola più diffuse ci sono il <a href={'https://www.petpassion.tv/blog/cani-di-razza-cucciolo-maltese-standard-28581'} targte={'_blank'}>Maltese</a>, il Volpino e il <a href={'https://www.petpassion.tv/blog/bulldog-inglese-bellissimo-%E2%80%A6-nella-sua-bruttezza-2248'} targte={'_blank'}>Bulldog Inglese</a>.   </Fragment>}
                        />

                        <AccordionBlock
                            titleAccordion={'Razze di cani da pastore'}
                            bodyAccordion={<Fragment>
                                Con questa terminologia si usa indicare i cani che hanno aiutato l’uomo nella <b className={'bolder-text'}>pratica dell’allevamento e della pastorizia</b>. I cani da pastore si suddividono in due categorie:
                                <ul  className={'text-left-block'}>
                                    <li >pastori conduttori, ossia quelli che guidavano il gregge;</li>
                                    <li >pastori custodi, volti alla difesa del bestiame da ladri e predatori.</li>
                                </ul>

                                Ad oggi questa tipologia di animali viene utilizzata per scopi diversi da quelli legati alla pastorizia, ma resta viva comunque la loro predisposizione ad essere di<b className={'bolder-text'}> aiuto nelle attività dell’uomo</b>;
                                per questo motivo molte razze di cani da pastore vengono usate per la <b>pet therapy, in Polizia o come cani-guida</b> per i non vedenti.
                                Una delle razze di cani pastore più note è il <a href={'https://www.petpassion.tv/blog/border-collie-caratteristiche-e-carattere-21104'} target={'_blank'}>Border Collie</a>,
                                ma di questa categoria fanno parte anche il <a href={'https://www.petpassion.tv/blog/bobtail-gigante-sornione-3382'} target={'_blank'}>Bobtail</a>
                                e il <a href={'https://www.petpassion.tv/blog/pet-foto-belle-cane-pastore-australiano-29152'} target={'_blank'}>Cane pastore australiano</a>, solo per fare qualche esempio.

                            </Fragment>}
                        />



                        <AccordionBlock
                            titleAccordion={'Razze di cani europei'}
                            bodyAccordion={<Fragment>
                                La storia dei cani europei è molto antica, se si pensa che i resti più antichi attribuibili
                                ad animali addomesticati sono stati ritrovati in Germania: si tratta di una mascella di cane
                                risalente a ben 14.700 anni fa. Recenti studi hanno quindi confermato che <b className={'bolder-text'}>il genoma dei cani europei
                                antichi è molto simile a quello dei cani europei</b>, arrivando alla conclusione che la maggioranza dei cani
                                domestici ha un’unica origine genetica e che il <b className={'bolder-text'}>processo di addomesticazione è avvenuto in Europa</b>.
                                Sono infatti moltissimi le razze di <b className={'bolder-text'}>cani provenienti da paesi europei</b>, come Francia, Germania e Spagna.
                                Ecco tre esempi di razze europee.
                                <ul  className={'text-left-block'}>
                                    <li><a href={'https://www.petpassion.tv/blog/carattere-e-caratteristiche-del-boxer-20999'} target={'_blank'}> Boxer </a></li>
                                    <li><a href={'https://www.petpassion.tv/blog/dogo-di-bordeaux-il-cane-piu-antico-deuropa-2559'} target={'_blank'}> Dogo di Bordeaux </a></li>
                                    <li><a href={'https://www.petpassion.tv/blog/lo-standard-del-border-collie-19315'} target={'_blank'}> Border Collie </a></li>
                                </ul>

                            </Fragment>}
                        />
                        <AccordionBlock
                            titleAccordion={'Tutte le razze di cani meticci'}
                            bodyAccordion={<Fragment>
                                Con questa terminologia ci si riferisce a <b className={'bolder-text'}>cani di razza non pura</b>, ossia derivanti
                                dall’accoppiamento di cani di razze diverse oppure di altri cani meticci.
                                Non avendo le caratteristiche tipiche di una razza precisa, <b className={'bolder-text'}>è impossibile categorizzarli all’interno
                                di un preciso standard</b>: esistono infatti cani meticci di tutte le taglie, colori e caratteri.
                                Non si può quindi dare una descrizione univoca di questi animali, perché sono molto eterogenei
                                e le loro peculiarità variano in base all’ambiente in cui crescono e ai genitori da cui sono nati.
                                In linea generale l’unica cosa che accomuna tutti i cani meticci è la loro <b className={'bolder-text'}>longevità</b>, dovuta sia al
                                mescolamento di razze diverse sia alla selezione naturale, che invece per i cani di razza è spesso ostacolata.
                                I cani meticci, quindi, sono generalmente <b className={'bolder-text'} >meno inclini a contrarre malattie e hanno un’aspettativa di vita più
                                lunga</b> rispetto ai cani di razza pura. Di contro, il loro valore commerciale è molto basso, tanto che nella gran
                                parte dei cani si tratta di cani che non si comprano, ma che si adottano. Purtroppo, questi cani sono soggetti,
                                più dei cani di razza, ad essere abbandonati e a diventare <b className={'bolder-text'}>cani randagi</b>, altro motivo che li ha resi nel tempo più resistenti alle malattie.
                                Chi sceglie di adottare un cane meticcio fa nella gran parte dei casi una scelta di cuore, perché <b className={'bolder-text'}>vuole aiutare
                                un animale in difficoltà</b> o perché non è interessato ad avere un cane di razza, ma solo a vivere con un animale da compagnia.
                                Non bisogna infatti pensare che i meticci non siano all’altezza dei loro fratelli più conosciuti: ci sono cani meticci bellissimi
                                e perfetti per vivere in serenità all’interno del contesto familiare.

                            </Fragment>}
                        />


                    </div>
                    <div className={'item'} id={'right'} >
                        <div>
                            <p className={'title-right'}>Articoli Correlati</p>

                              <BannerBlock
                                testo={'Cani con le orecchie lunghe: quali sono le razze'}
                                urlImage={ 'https://d5eqtiipdfno8.cloudfront.net/uploads/2020/07/3-8-657x360.jpg' }
                                pageurl={'https://www.petpassion.tv/blog/razze-di-cani-con-le-orecchie-lunghe-60615'}
                              />
                            <BannerBlock
                                testo={'Quali sono le razze di cani con la lingua blu?'}
                                urlImage={ 'https://d5eqtiipdfno8.cloudfront.net/uploads/2020/07/27_07_2020-2-657x360.jpg' }
                                pageurl={'https://www.petpassion.tv/blog/razze-di-cani-con-la-lingua-blu-60584'}
                            />
                            <BannerBlock
                                testo={'Quali sono le razze canine più adatte alle persone anziane?'}
                                urlImage={ 'https://d5eqtiipdfno8.cloudfront.net/uploads/2018/06/11.06_Razze-cani-anziani-1-657x360.png' }
                                pageurl={'https://www.petpassion.tv/blog/scegliere-razze-cane-persone-anziane-53406'}
                            />

                            <BannerBlock
                                testo={'Quali sono le razze canine più adatte alle persone anziane?'}
                                urlImage={ 'https://d5eqtiipdfno8.cloudfront.net/uploads/2018/06/17.07_Razze-di-cani-da-campagna-657x360.jpg' }
                                pageurl={'https://www.petpassion.tv/blog/scegliere-razze-cane-persone-anziane-53406'}
                            />

                            <BannerBlock
                                testo={'Quali sono i migliori cani da guardia?'}
                                urlImage={ 'https://d5eqtiipdfno8.cloudfront.net/uploads/2019/06/03.07-657x360.jpg' }
                                pageurl={'https://www.petpassion.tv/blog/razze-migliori-cani-da-guardia-57534'}
                            />
                            <BannerBlock
                                testo={'Razze di cani da valanga, quali sono le migliori'}
                                urlImage={ 'https://d5eqtiipdfno8.cloudfront.net/uploads/2019/11/02.12_razze-cani-valanga-657x360.jpg' }
                                pageurl={'https://www.petpassion.tv/blog/razze-di-cani-da-valanga-58989'}
                            />




                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


document.addEventListener("DOMContentLoaded", () => {
    const mountPoint = document.getElementById("smistamento-razze");
    if(mountPoint)
        ReactDOM.render(<Smistamento />, mountPoint);
});


 